import React, { useEffect, useState } from "react";
import anime from "animejs";
import styled from "styled-components";
import { unlockState } from "@stores/modal";
import { includes } from "lodash";
import { unlockBookStore } from "@stores/bookdata";
import { trialService } from "@/data/data";
import { useAtom } from "jotai";
import { blockTouch } from "@stores/vars";
import useModal from "@hooks/useModal";

const Wrap = styled.div`
  position: fixed;
  width: 1920px;
  height: 1200px;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Box = styled.div`
  position: relative;
  opacity: 0;
  width: 972px;
  height: 620px;
  border-radius: 90px;
  background-color: #ff665f;
  &.incorrect {
    animation: horizontal-shaking 0.5s;
  }
`;

const UnLockImage = styled.img`
  position: absolute;
  left: 105px;
  top: 60px;
  width: 375px;
  height: 479px;
`;

const Nums = styled.div`
  position: absolute;
  right: 35px;
  top: 60px;
  width: 400px;
  height: 520px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

const Num = styled.button`
  width: 100px;
  height: 100px;
  background-color: #dd4d47;
  color: #fff;
  margin: 15px;
  border-radius: 50px;
  font-size: 50px;
  &:active {
    background-color: #333;
    color: #fff;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  left: 0;
  top: 100px;
  color: #fff;
  font-size: 40px;
  width: 145px;
  height: 123px;
  background: url(${require("@assets/img/icon_popup_back.png")}) no-repeat;
  background-size: 100% 100%;
`;

const InputPasswordText = styled.div`
  position: absolute;
  top: 454px;
  left: 127px;
  &.on {
    &.p1 {
      &:after {
        content: "*";
        display: inline-block;
        font-size: 80px;
        color: #ff665f;
      }
    }
    &.p2 {
      &:after {
        content: "*";
        display: inline-block;
        font-size: 80px;
        color: #ff665f;
        position: absolute;
        left: 96px;
      }
    }
    &.p3 {
      &:after {
        content: "*";
        display: inline-block;
        font-size: 80px;
        color: #ff665f;
        position: absolute;
        left: 194px;
      }
    }
    &.p4 {
      &:after {
        content: "*";
        display: inline-block;
        font-size: 80px;
        color: #ff665f;
        position: absolute;
        left: 287px;
      }
    }
  }
`;

const IncorrectPaaword = styled.div`
  position: absolute;
  left: 160px;
  bottom: 30px;
  font-size: 30px;
  color: #ffe400;
  display: none;
`;

const asdad2324 =
  trialService === true
    ? ["1979"]
    : [
        "0014",
        "0061",
        "0016",
        "0023",
        "0015",
        "0053",
        "0049",
        "0022",
        "0057",
        "0029",
        "0048",
        "0012",
        "0047",
        "0031",
        "0045",
        "0024",
        "0055",
        "0058",
        "0062",
        "0030",
        "0042",
        "0028",
        "0037",
        "0043",
        "0054",
        "0020",
        "0036",
        "0026",
        "0041",
        "0052",
        "0035",
        "0018",
        "0034",
        "0039",
        "0019",
        "0020",
        "0018",
        "0055",
        "0041",
        "0047",
        "0029",
        "0045",
        "0036",
        "0031",
        "0039",
        "0023",
        "0057",
        "0018",
        "0020",
        "0034",
        "0022",
      ];

const UnLock = () => {
  const [unlockData, setUnlockPopup] = useAtom(unlockState);
  const [curPassword, setPassword] = useState("");
  const [unlockedList, setUnLock] = useAtom(unlockBookStore);
  const { showAlert } = useModal();
  const resetPassword = trialService === true ? "1979" : "7202";
  const imgurl =
    unlockData.data === "resetMode"
      ? require("@assets/img/unlock_img2.png")
      : require("@assets/img/unlock_img.png");
  const unLockGroup = () => {
    const before = [...unlockedList];

    const currentContentKey =
      unlockData.data.key.indexOf("c8") > -1 ? "c8-01" : unlockData.data.key;
    const splitKey = currentContentKey.split("-");
    const momKey = splitKey[0];
    const currentKeyNum = Number(splitKey[1]);
    const unLockLastKeyNum = Math.ceil(currentKeyNum / 4) * 4;
    const lastKey = `${momKey}-${String(unLockLastKeyNum).padStart("2", "0")}`;
    const lastKeyIndex = window.__flatKeys.indexOf(lastKey);

    for (let i = 0; i <= lastKeyIndex; i++) {
      const addKey = window.__flatKeys[i];
      if (before.indexOf(addKey) === -1) {
        before.push(addKey);
      }
    }

    if (currentContentKey.indexOf("c8") > -1) {
      console.log("before:", before);
      before.push("c8-05");
    }

    setUnLock(before);
    showAlert("잠금이 해제되었습니다.", "alert");
    onClose();
  };

  const lockReset = () => {
    const a =
      trialService === true
        ? ["c1-01", "c2-01", "c3-01"]
        : [
            "c1-01",
            "c2-01",
            "c3-01",
            "c4-01",
            "c5-01",
            "c6-01",
            "c7-01",
            "c8-01",
          ];
    setUnLock(a);
    showAlert("잠금이 초기화 되었습니다.", "alert");
    onClose();
  };

  //
  const onEnter = () => {
    if (includes(asdad2324, curPassword) && unlockData.data !== "resetMode") {
      unLockGroup();
    } else if (curPassword === resetPassword) {
      lockReset();
    } else {
      document.querySelector(".password-box-wrap").classList.add("incorrect");
      document.querySelector(".incorrect-text").style.display = "block";
      blockTouch();
      setTimeout(() => {
        document
          .querySelector(".password-box-wrap")
          .classList.remove("incorrect");
        document.querySelector(".incorrect-text").style.display = "none";
        setPassword("");
        blockTouch(false);
      }, 500);
    }
    //
  };

  const onClose = () => {
    setUnlockPopup({
      show: false,
      data: null,
    });
  };

  useEffect(() => {
    // const a = curPassword.length;
    if (curPassword.length === 4) {
      onEnter();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curPassword]);

  useEffect(() => {
    anime({
      targets: ".password-box-wrap",
      opacity: [0, 1],
      scale: [0.6, 1],
      easing: "easeOutBack",
      duration: 500,
    });
  }, []);

  return (
    <Wrap>
      <Box className="password-box-wrap">
        <CloseButton type="button" onClick={onClose} />
        <UnLockImage src={imgurl} alt="" />
        {["p1", "p2", "p3", "p4"].map((id, i) => {
          return (
            <InputPasswordText
              key={id}
              className={`${id} ${i < curPassword.length ? "on" : ""}`}
            />
          );
        })}
        <IncorrectPaaword className="incorrect-text">
          잘못된 비밀번호입니다.
        </IncorrectPaaword>
        <Nums>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((num) => {
            return (
              <Num
                type="button"
                key={num}
                onClick={() => {
                  if (curPassword.length < 4) {
                    const before = curPassword;
                    setPassword(before + num);
                  }
                }}
              >
                {num}
              </Num>
            );
          })}
        </Nums>
      </Box>
    </Wrap>
  );
};

export default UnLock;
